import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Job: { keyFields: ['cloudId'] },
  JobRecurrence: { keyFields: ['cloudId'] },
  Task: { keyFields: ['cloudId'] },
  User: { keyFields: ['cloudId'] },
  Template: { keyFields: ['cloudId'] },
  UserFilter: { keyFields: ['cloudId'] },
  JobComment: { keyFields: ['cloudId'] },
  Notification: { keyFields: ['cloudId'] },
  Client: { keyFields: ['cloudId'] },
  FamilyGroup: { keyFields: ['cloudId'] },
  Entity: { keyFields: ['cloudId'] },
  Query: {
    fields: {
      getNotificationList: {
        keyArgs: [
          'parameters',
          ['sortColumns', 'sortDirection', 'listType', 'filters'],
        ],
        // FIXME
        merge(existing, incoming, options) {
          if (!existing) return incoming;

          if (incoming === existing) return existing;

          if (!options.variables?.afterCursor) return incoming;

          return {
            ...incoming,
            data: [...existing.data, ...incoming.data],
          };
        },
      },
      jobGetRecurrences: {
        keyArgs: ['parameters', ['sortColumns', 'sortDirection']],
        // FIXME
        merge(existing, incoming, options) {
          if (!existing) return incoming;

          if (incoming === existing) return existing;

          if (!options.variables?.afterCursor) return incoming;

          return {
            ...incoming,
            data: [...existing.data, ...incoming.data],
          };
        },
      },
    },
  },
};
